export const PAGE_TOUR_EVENT = 'familysafe:page-tour';

export function dispatchPageTour(): void {
  if (typeof window === 'undefined') {
    return;
  }

  window.dispatchEvent(new CustomEvent(PAGE_TOUR_EVENT));
}
